<template>
  <div
    class="personalHead"
    :class="{
      initiationHeader: ['initiation_single', 'initiation_batch'].includes(
        type
      ),
    }"
  >
    <template v-if="!['initiation_single', 'initiation_batch'].includes(type)">
      <div class="logo-box">
        <!-- 原logo -->
        <img
          src="../../assets/images/image/head/logo.png"
          v-if="!ENABLEINTEGRATION_VALUE"
          alt
          class="logo"
        />
        <!-- 调赋一体化logo -->
        <img
          src="../../assets/images/integration/logo.png"
          alt
          v-else
          class="logo2"
          style="cursor: pointer"
          @click="goHome"
        />
      </div>
      <div
        class="tabs"
        v-if="ENABLEINTEGRATION_VALUE"
        :style="{ width: !tjFlag && gzcFlag ? '290px' : '192px' }"
      >
        <div class="tab" @click="onTab" v-if="!tjFlag">
          <div>在线调解</div>
        </div>
        <div class="tab active" v-if="!tjFlag || (tjFlag && gzcFlag)">
          <div>赋强公证</div>
          <div class="line"></div>
        </div>
        <div class="tab" @click="onGzcTab" v-if="gzcFlag">
          <div>公证处</div>
        </div>
      </div>
    </template>
    <div class="logo-box logo-box-initiation" v-else>
      <img
        src="../../assets/images/image/head/close.png"
        alt
        class="logo_close"
        style="cursor: pointer"
        @click="onCloseClick"
        v-if="logoCloseShow"
      />
      <div v-else class="logo_close"></div>

      <div class="line"></div>
      <div class="title">
        {{ titleNamePrefix || "" }}<span class="red">{{ titleName }}</span>
      </div>
    </div>
    <div class="user">
      <!-- <span class="warning cursorPointer" v-if="!allTipCount">
        <img
          class="noWarning"
          src="../../assets/images/personalHead/information_icon_nor.png"
          alt
          srcset
        >
        <img
          class="iswarning"
          src="../../assets/images/personalHead/information_icon_hov_pre.png"
          alt
          srcset
        >
      </span> -->

      <!-- 通知 -->
      <!-- <el-tooltip placement="bottom" effect="light" popper-class="notifyPoper" v-if="allTipCount">
        <span class="warning cursorPointer">
          <img
            class="noWarning"
            src="../../assets/images/personalHead/information_icon_nor.png"
            alt
            srcset
          >
          <img
            class="iswarning"
            src="../../assets/images/personalHead/information_icon_hov_pre.png"
            alt
            srcset
          >
          <span class="num ft12" v-if="allTipCount">{{allTipCount}}</span>
        </span>
        <div slot="content" class="notifyList">
          <div class="title">
            <div>
              <span class="titleFlag"></span>
              <span>您一共有{{allTipCount}}条消息</span>
            </div>
            <div class="forgetAll cursorPointer" @click="forget('all')">忽略全部</div>
          </div>
          <ul>
            <li class="item" v-for="item in notifyArray" :key="item.id">
              <div class="label ellipsis">{{item.noitceContent}}</div>
              <span class="toDetail cursorPointer" @click="forget('part',item)">忽略</span>
            </li>
          </ul>
          <div class="more" v-if="allTipCount>5">
            <i class="el-icon-arrow-down moreIcon" v-if="!isAllTip"></i>
            <i class="el-icon-arrow-up moreIcon" v-if="isAllTip"></i>
            <span class="moreDscp" v-if="!isAllTip" @click="getTip('all')">查看更多</span>
            <span class="moreDscp" v-if="isAllTip" @click="getTip()">收起</span>
          </div>
        </div>
      </el-tooltip> -->

      <div class="userInfo">
        <!-- <el-tooltip
          placement="bottom-end"
          effect="light"
          popper-class="notifyPoper_two notifyPoper_cz"
          :visible-arrow="false"
        > -->
        <img
          class="userPhoto"
          src="../../assets/images/image/head/userIcon.png"
          alt=""
        />
        <!-- <div slot="content" class="userDetail ft14">
            <p @click="bindAct" class="ft14">
              绑定手机号
              <i
                v-if="result.mobile == ''"
                class="update"
                @click="handelClick()"
                >绑定</i
              >
              <i v-else class="update" @click="handelClicks()">修改</i>
            </p>
            <p @click="bindAct" class="ft14">
              绑定邮箱
              <i v-if="result.mail == ''" class="update" @click="eMailFn"
                >绑定</i
              >
              <i v-else class="update" @click="eMailFns">修改</i>
            </p>
            <p class="ft14">
              登录密码
              <i
                v-if="result.existLoginPwd == 1"
                @click="toSetLoginPwd(result.existLoginPwd)"
                class="update"
                >设置</i
              >
              <i
                v-else
                @click="toSetLoginPwd(result.existLoginPwd)"
                class="update"
                >修改</i
              >
            </p>
            <p @click="toSetSignPwd(result.existSginPwd)" class="ft14">
              签约密码
              <i
                class="existSginPwd update"
                v-if="result.existSginPwd == 1"
                @click="toSetSignPwd(result.existSginPwd)"
                >设置</i
              >
              <i
                class="existSginPwd update"
                v-else
                @click="toSetSignPwd(result.existSginPwd)"
                >修改</i
              >
            </p>
            <p class="cursorPointer outLoigin" @click="back">退出登录</p>
          </div>
        </el-tooltip> -->
        <el-tooltip
          placement="bottom-end"
          :class="[
            'user_title_box',
            showIndex == 5 && isShowGuide ? 'guide' : '',
          ]"
          effect="light"
          popper-class="notifyPoper_two notifyPoper_user"
          :visible-arrow="false"
        >
          <div class="user_title" @mouseover="lookIcon" @mouseleave="closeFlag">
            <div class="user_name">
              <div
                class="userName cursorPointer"
                @click="toPersonCenter"
                :style="{
                  color: ['initiation_single', 'initiation_batch'].includes(
                    type
                  )
                    ? '#333333'
                    : '',
                }"
              >
                {{
                  userInfo && userInfo.person
                    ? userInfo.person.authenticationStatus != 0
                      ? nameSub(userInfo.person.realName)
                      : userInfo.person.mobile
                    : ""
                }}
              </div>
              <div
                class="identity_box"
                :class="{
                  identity_box_initiaion: [
                    'initiation_single',
                    'initiation_batch',
                  ].includes(type),
                }"
              >
                <span v-if="currentInfo && currentInfo.roleCode">
                  {{
                    currentInfo
                      ? currentInfo.authenticationStatus != 0
                        ? nameSub(currentInfo.deptName) || nameSub(currentInfo.realName)
                        : currentInfo.mobile
                        ? currentInfo.mobile
                        : currentInfo.mail
                      : ""
                  }}
                  |
                </span>
                {{
                  currentInfo && currentInfo.roleCode
                    ? currentInfo.roleCode == "SADMIN"
                      ? "管理员"
                      : currentInfo.roleCode == "ASSISTANT"
                      ? "业务人员"
                      : "代理人"
                    : "自然人"
                }}
              </div>
            </div>

            <i
              class="el-icon-arrow-down iconfont"
              v-if="lookFlag"
              :style="{
                color: ['initiation_single', 'initiation_batch'].includes(type)
                  ? '#333333'
                  : '',
              }"
            ></i>
            <i
              class="el-icon-arrow-up iconfont"
              v-else
              :style="{
                color: ['initiation_single', 'initiation_batch'].includes(type)
                  ? '#333333'
                  : '',
              }"
            ></i>
          </div>
          <div
            slot="content"
            @mouseover="lookIcon"
            @mouseleave="closeFlag"
            class="userList ft14"
            v-if="!isShowGuide"
          >
            <div
              class="user_list_item"
              @click="changeAccount(accountInfo)"
              v-for="(accountInfo, index) in userInfo
                ? [...[userInfo.person], ...userInfo.enterpriseList]
                : []"
              :key="index"
            >
              <div class="userInfo_sign_con_box">
                <!-- <template v-if="自然人"> -->

                <!-- 图标 -->
                <template v-if="accountInfo.userId === currentInfo.userId">
                  <img
                    v-if="
                      accountInfo.roleCode &&
                      (accountInfo.roleCode == 'SADMIN' ||
                        accountInfo.roleCode == 'ASSISTANT')
                    "
                    class="role-image"
                    src="../../assets/images/index/qy_a.png"
                    alt=""
                  />
                  <img
                    v-else-if="
                      accountInfo.roleCode && accountInfo.roleCode == 'AGENT'
                    "
                    class="role-image"
                    src="../../assets/images/index/dlr_a.png"
                    alt=""
                  />
                  <img
                    v-else
                    class="role-image"
                    src="../../assets/images/index/zrr_a.png"
                    alt=""
                  />
                </template>
                <template v-else>
                  <img
                    v-if="
                      accountInfo.roleCode && accountInfo.roleCode == 'SADMIN'
                    "
                    class="role-image"
                    src="../../assets/images/index/qy.png"
                    alt=""
                  />
                  <img
                    v-else-if="
                      accountInfo.roleCode && accountInfo.roleCode == 'AGENT'
                    "
                    class="role-image"
                    src="../../assets/images/index/dlr.png"
                    alt=""
                  />
                  <img
                    v-else
                    class="role-image"
                    src="../../assets/images/index/zrr.png"
                    alt=""
                  />
                </template>

                <!-- <div class="identity_label">自然人</div> -->
                <div class="identity_label">
                  <div
                    class="role-text"
                    :class="{
                      'role-active': accountInfo.userId === currentInfo.userId,
                    }"
                  >
                    {{
                      accountInfo.authenticationStatus != 0
                        ? accountInfo.deptName || accountInfo.realName
                        : accountInfo.mobile
                        ? accountInfo.mobile
                        : accountInfo.mail
                    }}
                    {{
                      accountInfo.roleCode
                        ? accountInfo.roleCode == "SADMIN"
                          ? "| 管理员"
                          : accountInfo.roleCode == "ASSISTANT"
                          ? "| 业务人员"
                          : "| 代理人"
                        : "自然人"
                    }}
                  </div>
                  <div class="no-auth">
                    <div
                      class="no-auth-tag"
                      v-if="accountInfo.authenticationStatus != 2"
                    >
                      未认证
                    </div>
                  </div>
                  <div class="check-auth">点击切换此账户</div>
                </div>

                <!-- </template> -->
                <!-- <span class="userInfo_title" :style="{ color: '#505050' }">
                  {{
                    accountInfo.authenticationStatus != 0
                      ? accountInfo.realName
                      : accountInfo.mobile
                      ? accountInfo.mobile
                      : accountInfo.mail
                  }}
                  {{
                    accountInfo.roleCode
                      ? accountInfo.roleCode == "SADMIN"
                        ? "管理员"
                        : "代理人"
                      : "自然人"
                  }}
                </span> -->

                <!-- 实名图标 -->
                <!-- <span
                  :class="[
                    'sign_status_con',
                    `sign_status_con_${accountInfo.authenticationStatus}`,
                  ]"
                  style="width: 74px"
                >
                  <span
                    class="sign_icon"
                    :class="`sign_img_${accountInfo.authenticationStatus}`"
                  ></span>
                  <span class="sign_name">{{
                    AUTHENTICATION_STATUS[accountInfo.authenticationStatus]
                  }}</span>
                </span> -->
              </div>

              <!-- <img
                class="checked"
                v-show="
                  accountInfo.realName === currentInfo.realName &&
                  (userInfo.currentUserType == 2
                    ? accountInfo.roleCode === userInfo.currentUserRoleCode
                    : true)
                "
                src="../../assets/images/userHome/selected_icon.png"
              /> -->
            </div>
            <!-- 创建企业 -->
            <p
              class="cursorPointer add_enterprise"
              @click="addEnterprise"
              v-show="!getUserInfo.enterpriseList.length"
            >
              <i class="add_icon"></i>创建企业
            </p>
            <div class="cursorPointer outLoigin" @click="back">退出登录</div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <!-- 实名认证 -->
    <Dialog
      :visible="authDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>您还没有通过实名认证，</p>
          <p>无法发起签约，请去实名认证！</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center">
          <!-- <div class="button cursorPointer" @click="closeDialog('authDialogShow')">取消</div> -->
          <div class="button buttonActive cursorPointer" @click="goAuth">
            去认证
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 绑定手机号 -->
    <Dialog
      :visible="dialogVisiblePhtot"
      :dialogTitle="'绑定手机号'"
      v-on:closeDialog="closeDialog"
      :width="'450px'"
    >
      <div slot="dialog" class="sheHints">
        <setphoto
          :message="result"
          @closeDialog="closeDialog"
          @init="init"
        ></setphoto>
      </div>
    </Dialog>
    <!-- 更换绑定手机号 -->
    <Dialog
      :visible="dialogVisiblePhtot1"
      :dialogTitle="'更换绑定手机号'"
      v-on:closeDialog="closeDialog"
      :width="'450px'"
    >
      <div slot="dialog" class="sheHint">
        <p class="hint">当前手机号：{{ result.mobile }}</p>
        <setphoto
          :message="result"
          @closeDialog="closeDialog"
          @init="init"
        ></setphoto>
      </div>
    </Dialog>
    <!-- 绑定邮箱 -->
    <Dialog
      :visible="dialogVisibleEmail"
      :dialogTitle="'绑定邮箱'"
      v-on:closeDialog="closeDialog"
      :width="'450px'"
    >
      <div slot="dialog" class="sheHints">
        <setemail
          :message="result"
          @closeDialog="closeDialog"
          @init="init"
        ></setemail>
      </div>
    </Dialog>
    <!-- 更换绑定邮箱  -->
    <Dialog
      :visible="dialogVisibleEmail1"
      :dialogTitle="'更换绑定邮箱'"
      v-on:closeDialog="closeDialog"
      :width="'450px'"
    >
      <div slot="dialog" class="sheHint">
        <p class="hint">当前邮箱：{{ result.mail }}</p>
        <setemail
          :message="result"
          @closeDialog="closeDialog"
          @init="init"
        ></setemail>
      </div>
    </Dialog>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import { mapState, mapMutations, mapGetters } from "vuex";
import Dialog from "@common/Dialog.vue";
import setphoto from "../personal/user/components/safety/Setphoto.vue";
import setemail from "../personal/user/components/safety/Setemail.vue";
export default {
  props: {
    showIndex: {},
    isShowGuide: {},
    type: {
      type: String,
      default: "",
    },
    titleNamePrefix: {
      type: String,
      default: "",
    },
    titleName: {
      type: String,
      default: "",
    },
    logoCloseShow: {
      type: Boolean,
      default: true,
    },
    backPath: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      result: {},
      userName: "",
      notifyArray: [],
      allTipCount: 0,
      isAllTip: false,
      userStatusUrl: "",
      lookFlag: true,
      authDialogShow: false,
      dialogVisiblePhtot: false, //手机号
      dialogVisiblePhtot1: false,
      succeefulBox: true,
      dialogVisibleEmail: false, //邮箱
      dialogVisibleEmail1: false,
      AUTHENTICATION_STATUS: {
        0: "未实名",
        1: "审核中",
        2: "已实名",
        3: "认证失败",
        4: "锁定",
        5: "认证失败", // 认证一半退出
        6: "认证失败",
      },

      ENABLEINTEGRATION_VALUE: false, // 是否开启调赋一体化
      gzcFlag: false, // 公证处开关
      tjFlag: false, // tjFlag 参数是否隐藏调解 false显示 true隐藏
    };
  },
  components: {
    Dialog,
    setphoto,
    setemail,
  },
  mounted() {
    this.userName = localStorage.getItem("userName");
    this.init();
    // this.getTip();

    let ENABLEINTEGRATION = JSON.parse(
      sessionStorage.getItem("ENABLEINTEGRATION")
    ) || {
      flag: 0,
      value: null, // 调赋一体化
    };
    if (ENABLEINTEGRATION.value) {
      this.ENABLEINTEGRATION_VALUE = ENABLEINTEGRATION.value;
    }
  },
  created() {
    this.getuserInof();
    this.gzcFlag = sessionStorage.getItem("gzcFlag") == "true" ? true : false;
    this.tjFlag = localStorage.getItem("tjFlag") ? true : false;

    console.log(this.currentInfo, "currentInfo");
  },
  computed: {
    ...mapState(["userInfo", "currentInfo", "updateUserState"]),
    ...mapGetters(["getUserInfo"]),
  },
  methods: {
    ...mapMutations(["setUserInfo", "setCurrentInfo", "setCurState"]),
    init() {
      BaseApi.createRpcToken("/user/getSecurityInfo")
        .then(
          (data) => {
            if (data.datas.success === true) {
              this.result = data.datas.info;
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    lookIcon() {
      this.lookFlag = false;
    },
    closeFlag() {
      this.lookFlag = true;
    },
    closeDialog(data) {
      this.dialogVisiblePhtot = data;
      this.dialogVisibleEmail = data;
      this.dialogVisiblePhtot1 = data;
      this.dialogVisibleEmail1 = data;
      this.succeefulBox = true;
    },
    handelClick() {
      this.dialogVisiblePhtot = true;
    },
    handelClicks() {
      this.dialogVisiblePhtot1 = true;
    },
    eMailFn() {
      this.dialogVisibleEmail = true;
    },
    eMailFns() {
      this.dialogVisibleEmail1 = true;
    },
    //去认证
    goAuth() {
      let exuserid = sessionStorage.getItem("userInfo")
        ? JSON.parse(sessionStorage.getItem("userInfo"))
        : "";
      console.log(this.currType, exuserid);
      if (this.currType == 2) {
        this.$router.push({
          path: "/personal/users/enterprise",
          query: {
            step: this.step,
            exId: exuserid.enterpriseList.length
              ? exuserid.enterpriseList[0].userId
              : "",
          },
        });
      } else {
        this.$router.push({
          path: "/personal/users/PersonalCertificate",
          query: {
            userId: exuserid.person.userId,
          },
        });
      }
      this.authDialogShow = false;
    },
    //创建企业
    addEnterprise() {
      let exuserid = sessionStorage.getItem("userInfo")
        ? JSON.parse(sessionStorage.getItem("userInfo"))
        : "";
      console.log(
        ":Dsadasd",
        exuserid.enterpriseList.length
          ? exuserid.enterpriseList[0].userId
          : "2222222222222222222222"
      );
      this.$router.push({
        path: "/personal/users/enterprise",
        query: {
          step: this.step,
          exId: exuserid.enterpriseList.length
            ? exuserid.enterpriseList[0].userId
            : "",
        },
      });
    },
    getuserInof() {
      BaseApi.createRpcToken("/user/v2/getUserInfo").then(
        (data) => {
          sessionStorage.setItem("userInfo", JSON.stringify(data.datas));
          this.setUserInfo(data.datas);
          localStorage.loginType = "password";
          // this.$router.push({
          //   path: "/personal/home"
          // });
        },
        (err) => {}
      );
    },
    //切换个人实名身份
    changeAccount(accountInfo) {
      BaseApi.createRpcToken("/user/changeUser", {
        changeUserId: accountInfo.userId,
        roleCode: accountInfo.roleCode || "",
      })
        .then((data) => {
          if (data.datas.success) {
            this.setCurState(accountInfo.userId);
            let names =
              accountInfo.authenticationStatus != 0
                ? accountInfo.realName
                : accountInfo.mobile;
            localStorage.setItem("userName", names);
            localStorage.setItem("curID", accountInfo.userId);
            sessionStorage.setItem("userInfo", "");
            this.setCurrentInfo(accountInfo);
            this.getuserInof();
            this.init();
            this.getTip("all");
            this.$router.push("/personal/home");
            setTimeout(() => {
              location.reload();
            }, 500);
          }
        })
        .catch(function (e) {
          errorLog(e);
        });
      if (accountInfo.authenticationStatus == 2) {
        if (
          this.$route.path == "/personal/users/PersonalCertificate" ||
          this.$route.path == "/personal/users/enterprise"
        ) {
          this.toPersonCenter();
        }
      } else {
        this.currType = accountInfo.realNameType;
        console.log(this.$route.path);
        // this.authDialogShow=true;
        if (this.$route.path == "/personal/users/PersonalCertificate") {
          this.goUserRealname(this.currType);
        } else if (this.$route.path == "/personal/users/enterprise") {
          this.goUserRealname(this.currType);
        }
      }
    },
    //根据当前用户身份跳转实名
    goUserRealname(currType) {
      if (currType == 1) {
        this.$router.push("/personal/users/PersonalCertificate");
      } else {
        this.$router.push("/personal/users/enterprise");
      }
    },
    bindAct() {
      this.$router.push("/personal/users/home");
    },
    toPersonCenter() {
      this.$router.push("/personal/users/home");
    },
    toSetLoginPwd(flag) {
      //比较奇怪的是 0是已设置 1是未设置 容易出错
      if (flag == 0) {
        this.$router.push("/personal/users/safety/amendLoginpwd");
      } else {
        this.$router.push("/personal/users/safety/SetLoginPwd");
      }
    },
    toSetSignPwd(flag) {
      if (flag == 0) {
        this.$router.push("/personal/users/safety/amendSignPwd");
      } else {
        this.$router.push("/personal/users/safety/SetSignPwd");
      }
    },
    goHome() {
      location.href = process.env.VUE_APP_PARTY_INDEX;
    },
    forget(flag, item) {
      if (flag == "part") {
        BaseApi.createRpcToken("/home/readMessage", { id: item.id }, "post")
          .then(
            (data) => {
              if (this.isAllTip) {
                this.getTip("all");
              } else {
                this.getTip();
              }
            },
            (data) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
      } else {
        BaseApi.createRpcToken("/home/readMessageAll")
          .then(
            (data) => {
              if (this.isAllTip) {
                this.getTip("all");
              } else {
                this.getTip();
              }
            },
            (data) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
      }
    },
    getTip(flag) {
      let queryParams = {
        readFlag: 0,
      };
      if (flag != "all") {
        queryParams.pageSize = 5;
        this.isAllTip = false;
      } else {
        queryParams.pageSize = this.allTipCount;
        this.isAllTip = true;
      }
      BaseApi.createRpcToken("/home/notice", queryParams)
        .then(
          (data) => {
            this.notifyArray = data.datas.resultList;
            this.allTipCount = data.datas.count;
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    back() {
      // BaseApi.createRpcToken("/user/logout", {token:localStorage.getItem('token')})
      //   .then(
      //     (data) => {
      this.$router.push("/");
      localStorage.removeItem("token");
      localStorage.removeItem("tjFlag");
      // },
      //   (data) => {}
      // )
      // .catch(function (e) {
      //   errorLog(e);
      // });
    },

    // 调赋一体化  跳转至在线调解
    onTab() {
      if (sessionStorage.getItem("role") === "party") {
        location.href = process.env.VUE_APP_PARTY_HOME;
        +"?ht=" + localStorage.getItem("token");
      } else {
        location.href =
          process.env.VUE_APP_MEDIATOR_HOME +
          "?ht=" +
          localStorage.getItem("token") +
          "&gzcFlag=" +
          this.gzcFlag;
      }
    },
    // 调赋一体化  跳转公证处
    onGzcTab() {
      location.href =
        process.env.VUE_APP_GZC_HOME + "?ht=" + localStorage.getItem("token");
    },

    // 名字截取
    nameSub(name) {
      if (!name) {
        return name;
      }
      if (name.length > 6) {
        return name.substring(0, 6) + '...'
      }
      return name;
    },

    onCloseClick() {
      this.$emit('onClose');
      if (this.backPath) {
        this.$router.push({
          path: this.backPath
        })
      } else {
        this.$router.go(-1)
      }
    }
  },
  watch: {
    updateUserState() {
      this.init();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.userDetail {
  width: 250px;
  padding: 10px 0px;
  padding-bottom: 0px;
  border: 0;

  i {
    font-style: normal;
    float: right;
    color: #969696;
    cursor: pointer;
  }

  i.update {
    color: #ff4d4f;
    font-size: 14px;
    cursor: pointer;
  }

  p {
    font-size: 14px;
    line-height: 30px;
    color: #606972;
    padding: 0px 10px;
    box-sizing: border-box;
  }

  p:hover {
    background: rgb(248, 248, 248);
  }

  .outLoigin {
    width: 99%;
    border-top: 1px solid #ccc;
    text-align: center;
    margin-top: 10px;
    padding-top: 10px;
    font-size: 14px;
  }
}
.initiationHeader {
  background-color: #fff !important;
}
.user_title {
  max-width: 194px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;

  i {
    margin-left: 1px;
    color: #ffffff;
  }

  span {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}

.notifyPoper_user {
  position: absolute;
  margin-top: 7px !important;
  // top: 30px !important;
  // padding: 0px !important;
}

.userList {
  padding: 10px 0;
  width: 298px;
  .add_enterprise {
    width: 99%;
    border-top: 1px solid #ccc;
    margin-top: 10px;
    padding-top: 10px;
    font-size: 14px;
    color: #616b73;
    display: flex;
    align-items: center;
    justify-content: center;

    .add_icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~@image/userHome/increase_nor_icon.png");
      background-size: cover;
    }
  }
  .outLoigin {
    width: 146px;
    height: 28px;
    background: #db1c1b;
    border-radius: 2px;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    line-height: 28px;
    margin: 24px auto 0;
  }

  .add_enterprise:hover .add_icon {
    background: url("~@image/userHome/increase_hov_pre_icon.png");
    background-size: cover;
  }

  .user_list_item:hover {
    background: rgb(245, 245, 245);
  }

  .user_list_item {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    cursor: pointer;
    height: 81px;
    padding: 0 24px;
    position: relative;
    &::after {
      content: "";
      width: 250px;
      height: 1px;
      background-color: #e9e9e9;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .userInfo_sign_con_box {
      display: flex;
      align-items: flex-start;
      .role-image {
        width: 22px;
        height: 22px;
      }
      .identity_label {
        margin-left: 8px;
        color: #333333;
        font-size: 14px;
      }

      .role-text {
        font-weight: bold;
        color: #333333;
        line-height: 22px;
        margin-bottom: 5px;
        &.role-active {
          color: #db1c1b;
        }
      }

      .no-auth {
        margin-bottom: 4px;
        height: 15px;
        .no-auth-tag {
          width: 39px;
          height: 15px;
          background: #f5f5f5;
          font-weight: 400;
          color: #bdbdbd;
          line-height: 15px;
          font-size: 11px;
          text-align: center;
        }
      }

      .check-auth {
        font-weight: 400;
        color: #bdbdbd;
        line-height: 15px;
        font-size: 11px;
      }
    }

    .userInfo_title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      margin-right: 10px;
      font-size: 14px;
      flex-shrink: 0;
    }

    .sign_icon {
      width: 14px;
      height: 14px;
      margin-right: 4px;
      display: inline-block;

      &.sign_img_0 {
        background: url("~@image/userHome/unverified_icon.png") no-repeat;
        background-size: 100%;
      }

      &.sign_img_1 {
        background: url("~@image/userHome/verifieding_icon.png") no-repeat;
        background-size: 100%;
      }

      &.sign_img_2 {
        background: url("~@image/userHome/verified_icon.png") no-repeat;
        background-size: 100%;
      }

      &.sign_img_3,
      &.sign_img_5,
      &.sign_img_6 {
        background: url("~@image/userHome/close_circle.png") no-repeat;
        background-size: 100%;
      }
    }

    .sign_name {
      display: inline-block;
      line-height: 22px;
      font-size: 14px;
    }

    .checked {
      width: 14px;
      height: 14px;
    }

    .sign_status_con {
      font-size: 12px;
      display: flex;
      border-radius: 56px;
      text-align: center;
      line-height: 20px;
      padding: 0 8px;
      height: 22px;
      align-items: center;

      &.sign_status_con_0 {
        color: #b4b4b4;
      }

      &.sign_status_con_1 {
        color: #ffa940;
      }

      &.sign_status_con_2 {
        color: #73d13d;
      }

      &.sign_status_con_3,
      &.sign_status_con_5,
      &.sign_status_con_6 {
        color: #f86442;
      }
    }

    .sign_status_con_un {
      font-size: 11px;
      display: inline-block;
      border: 1px solid #dcdcdc;
      color: #c8c8c8;
      border-radius: 56px;
      width: 56px;
      height: 18px;
      text-align: center;
      line-height: 20px;
    }
  }
}

.notifyPoper_two {
  border: 0px !important;
  box-shadow: 0px 0px 5px #bebbbb;
}

.notifyPoper_cz {
  padding: 10px 0px;
}

.notifyList {
  width: 280px;
  padding-bottom: 21px;

  .title {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    width: 240px;
    margin: 0 auto;
    border-bottom: 1px dashed #c8c8c8;
    font-size: 14px;
    font-weight: 700;
    color: #505050;

    .titleFlag {
      display: inline-block;
      width: 2px;
      height: 14px;
      margin-right: 6px;
      background-color: #e88078;
      vertical-align: bottom;
    }

    .forgetAll {
      color: #c8c8c8;
    }
  }

  ul {
    max-height: 500px;
    overflow: auto;
  }

  .item {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 8px 20px;
    color: #787878;
    font-size: 12px;
    line-height: 16px;
    border-bottom: 1px solid #ebebeb;

    .toDetail {
      color: #e88078;
    }

    .label {
      width: 180px;
    }

    &:hover {
      background-color: #f5f5f5;
    }
  }

  .more {
    color: #646464;
    font-size: 12px;
    line-height: 30px;
    text-align: center;

    .moreDscp {
      margin-left: 10px;
    }

    .moreIcon {
      font-size: 14px;
    }
  }
}

.notifyPoper {
  padding: 0;
  border: 1px solid #ebebeb !important;
  box-shadow: 0px 0px 5px #ebebeb;
}

.personalHead {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #db1c1b;
  .logo-box {
    width: 236px;
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    left: 15px;
    top: 0;
    &.logo-box-initiation {
      width: 300px;
    }

    .logo_close {
      width: 32px;
      height: 32px;
      margin-right: 24px;
    }
    .line {
      width: 2px;
      height: 36px;
      background-color: #db1c1b;
      margin-right: 15px;
    }
    .title {
      font-weight: 700;
    }
    .red {
      color: #db1c1b;
    }
  }
  .logo {
    // position: absolute;
    // left: 1%;
    // top: 36%;
    // margin-top: -8px;
    width: 250px;
  }

  .logo2 {
    width: 247px;
  }

  .tabs {
    width: 290px;
    height: 100%;
    position: absolute;
    left: 300px;
    display: flex;
    align-items: center;
    font-size: 14px;

    .tab {
      flex: 1;
      height: 100%;
      color: #ffffff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      &.active {
        background: #a81b0f;
      }

      .line {
        width: 40px;
        height: 3px;
        background-color: #ffffff;
        position: absolute;
        bottom: 6px;
        left: 28px;
      }
    }
  }

  .user {
    float: right;
    height: 60px;
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 15px;
    .userName {
      display: inline-block;
      max-width: 170px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: #fff;
      margin-right: -16px;
    }

    .direction_con {
      width: 12px;
      height: 12px;
      display: inline-block;
      background: url("~@image/userHome/collapse_nor_icon.png");
    }

    .el-tooltip__popper {
      padding: 0;
    }

    .name {
      color: #fff;
      display: inline-block;
      margin-left: 5px;
      margin-right: 20px;

      .bas {
        display: inline-block;
      }

      .base {
        display: none;
      }

      .lower {
        margin-left: 6px;
        position: relative;
      }

      &:hover {
        .bas {
          display: none;
        }

        .base {
          display: inline-block;
        }
      }
    }

    .warning {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 0;

      .num {
        width: 20px;
        height: 20px;
        border-radius: 100%;
        background: #d81212;
        text-align: center;
        line-height: 20px;
        color: #fff;
        position: absolute;
        right: -12px;
        top: -14px;
      }

      .noWarning {
        display: inline-block;
      }

      .iswarning {
        display: none;
      }

      &:hover {
        .noWarning {
          display: none;
        }

        .iswarning {
          display: inline-block;
        }
      }
    }
  }

  .succeefulBox {
    width: 100%;
    height: 240px;
    padding: 92px 0;
    box-sizing: border-box;
  }

  .sheHint {
    overflow: hidden;

    .hint {
      color: #646464;
      text-align: center;
      margin: 28px 0;
      font-size: 14px;
      height: 18px;
    }
  }

  .sheHints {
    padding-top: 49px;
  }
}

.guide {
  position: relative;
  z-index: 999;
}

.userInfo {
  height: 100%;
  display: flex;
  align-items: center;
  .userPhoto {
    height: 30px;
    margin-right: 8px;
    width: 30px;
  }
  .iconfont {
    margin-left: 24px;
  }
}

.user_name {
  .identity_box {
    min-width: 124px;
    height: 17px;
    box-sizing: border-box;
    background: #b80000;
    color: #ffffff;
    text-align: center;
    font-size: 12px;
    line-height: 17px;
    &.identity_box_initiaion {
      background: #db1c1b;
    }
  }
}
</style>
